export default __webpack_public_path__ + "static/media/69t.e264ee9e.jpg";